const meta = {
  auth: true,
  layout: "main",
  role: ["academy", "admin", "bi", "teacher", "hr", "call", "audit", "instructor", "tutor", "kurator", "examiner", "hunter"],
  permission: "head_access",
};

export default [
  {
    path: "/statistics",
    name: "statistics-dashboard",
    component: () =>
      import("../../modules/Statistics/pages/StatisticsDashboard.vue"),
    meta,
  },
  {
    path: "/statistics/students",
    name: "statistics-students",
    component: () =>
      import("../../modules/Statistics/pages/StatisticsStudents.vue"),
    meta,
  },
  {
    path: "/statistics/cohorts",
    name: "statistics-cohorts",
    component: () =>
      import("../../modules/Statistics/pages/StatisticsCohorts.vue"),
    meta,
  },
];
